/**
 * Country Profile translations - Spanish
 */

export const countryProfile = {
  countryProfile: {
    // Page structure
    pageTitle: 'Perfil del País',
    backToRankings: 'Volver a Rankings',
    viewFullProfile: 'Ver Perfil Completo',
    
    // Hero section
    yfiScore: 'Índice de Futuros de la Juventud',
    vsGlobal: 'vs Promedio Global',
    classification: 'Clasificación',
    region: 'Región',
    
    // Quick stats
    youthPopulation: 'Población Joven',
    jciMembers: 'Miembros JCI',
    jciSince: 'JCI Desde',
    neetRate: 'Tasa NEET',
    
    // Section titles
    demographics: 'Demografía & Población',
    jciPresence: 'Presencia JCI',
    dimensionAnalysis: 'Análisis Dimensional',
    mentalHealth: 'Salud Mental',
    workforce: 'Trabajo & Educación',
    entrepreneurship: 'Emprendimiento',
    keyPrograms: 'Programas & Organizaciones Clave',
    sdgAlignment: 'Alineación con ODS',
    recommendations: 'Recomendaciones Estratégicas',
    communityImpact: 'Impacto Comunitario',
    
    // Demographics labels
    totalPopulation: 'Población Total',
    medianAge: 'Edad Mediana',
    urbanPopulation: 'Población Urbana',
    genderDistribution: 'Distribución por Género',
    racialComposition: 'Composición Racial',
    incomeDistribution: 'Distribución de Ingresos',
    
    // Racial composition
    pardo: 'Pardo (Mestizo)',
    preto: 'Preto (Negro)',
    branco: 'Branco (Blanco)',
    other: 'Otros',
    
    // Income levels
    highIncome: 'Ingresos Altos',
    upperMiddle: 'Medio-Alto',
    lowerMiddle: 'Medio-Bajo',
    lowIncome: 'Ingresos Bajos',
    
    // JCI Presence
    affiliationYear: 'Año de Afiliación',
    currentMembers: 'Miembros Actuales',
    yearOverYearGrowth: 'Crecimiento Anual',
    historicalPeak: 'Pico Histórico',
    memberProfile: 'Perfil de Miembros',
    ageDistribution: 'Distribución por Edad',
    educationLevel: 'Nivel de Educación',
    genderBalance: 'Equilibrio de Género',
    motivationLevel: 'Nivel de Motivación',
    higherEducation: 'Educación Superior',
    postGraduate: 'Posgrado',
    mastersOrHigher: 'Maestría o Superior',
    veryMotivated: 'Muy Motivado',
    motivated: 'Motivado',
    neutral: 'Neutral',
    demotivated: 'Desmotivado',
    
    // Challenges
    keyChallenges: 'Desafíos Clave',
    mentalHealthCrisis: 'Crisis de Salud Mental',
    climateAnxiety: 'Ansiedad Climática',
    youthAnxiety: 'Ansiedad Juvenil',
    frequentSadness: 'Tristeza Frecuente',
    frequentNervousness: 'Nerviosismo Frecuente',
    adolescentDisorders: 'Adolescentes con Trastornos',
    girlsAffected: 'Niñas Afectadas',
    boysAffected: 'Niños Afectados',
    highestGlobally: 'Más Alto Globalmente',
    neetPopulation: 'Jóvenes NEET',
    youth: 'Jóvenes',
    intersectionalGap: 'Brecha Interseccional',
    blackBrownWomen: 'Mujeres Negras/Pardas',
    whiteMen: 'Hombres Blancos',
    
    // Workforce labels
    // Workforce labels
    literacyCrisis: 'Tasa de Alfabetización (2º Año)',
    higherEducationGap: 'Brecha de Educación Superior',
    intersectionalNeet: 'NEET Interseccional',
    
    // Entrepreneurship labels
    blackEntrepreneurs: 'Emprendedores Negros',
    informalSector: 'En Sector Informal',
    microentrepreneurs: 'Microemprendedores (MEI)',
    earlyStageEntrepreneurship: 'Emprendimiento en Etapa Inicial',
    businessSurvivalRate: 'Supervivencia de Negocios (2 años)',
    
    // Programs
    programName: 'Programa',
    programFocus: 'Enfoque',
    programImpact: 'Impacto',
    
    // SDG
    sdgInitiatives: 'Iniciativas Clave',
    
    // Recommendations
    urgentPriorities: 'Prioridades Urgentes (0-6 meses)',
    mediumTermGoals: 'Metas a Medio Plazo (6-12 meses)',
    longTermVision: 'Visión a Largo Plazo (1-3 años)',
    
    // Common
    years: 'años',
    million: 'millones',
    thousand: 'mil',
    percent: '%',
    ofPopulation: 'de la población',
    source: 'Fuente',
    dataNote: 'Datos del Informe de Impacto JCI 2025, Atlas das Juventudes, IBGE, OMS',
    
    // Not found
    notFound: 'Perfil del país no encontrado',
    notFoundDescription: 'El perfil del país solicitado aún no está disponible.',
    browseRankings: 'Ver Rankings de Países',

    // NEW: Research Sources Section
    dataSources: 'Fuentes de Investigación',
    dataSourcesDescription: 'Fuentes primarias de datos utilizadas en este perfil de país',
    primarySources: 'Fuentes Primarias',
    methodology: 'Metodología',
    sampleSize: 'Tamaño de Muestra',
    confidenceLevel: 'Nivel de Confianza',
    organization: 'Organización',
    researchYear: 'Año',
    respondents: 'encuestados',
    
    // NEW: Violence & Safety Section
    violenceSafety: 'Violencia y Seguridad',
    violenceSafetyDescription: 'Indicadores críticos de seguridad que afectan a la juventud brasileña',
    youthHomicideShare: 'Proporción de Homicidios Juveniles',
    ofAllHomicides: 'de todos los homicidios',
    racialDisparity: 'Disparidad Racial',
    blackYouthMurderRisk: 'Riesgo de asesinato de jóvenes negros',
    timesHigher: 'veces mayor que jóvenes blancos',
    policeViolence: 'Violencia Policial',
    policeViolenceVictims: 'de las víctimas de violencia policial son negras',
    lgbtqiaViolence: 'Violencia LGBTQIA+',
    annualIncrease: 'aumento anual en violencia reportada',
    
    // NEW: Organizational Health Section
    organizationalHealth: 'Salud Organizacional',
    organizationalHealthDescription: 'Métricas de satisfacción y compromiso de los miembros de JCI Brasil',
    netPromoterScore: 'Net Promoter Score',
    excellent: 'Excelente',
    promoters: 'Promotores',
    passives: 'Pasivos',
    detractors: 'Detractores',
    localSatisfaction: 'Satisfacción con Org. Local',
    nationalSatisfaction: 'Satisfacción con Org. Nacional',
    outOfTen: 'de 10',
    npsBreakdown: 'Desglose NPS',
    satisfactionScores: 'Puntuaciones de Satisfacción',
    
    // NEW: SWOT Analysis Section
    swotAnalysis: 'Análisis FODA de Miembros',
    swotAnalysisDescription: 'Evaluación estratégica de la encuesta de miembros de JCI Brasil',
    strengths: 'Fortalezas',
    weaknesses: 'Debilidades',
    opportunities: 'Oportunidades',
    threats: 'Amenazas',
    membersIdentified: 'de los miembros identificaron',
    
    // NEW: Geographic Distribution Section
    geographicGap: 'Distribución Geográfica',
    geographicGapDescription: 'Concentración de miembros de JCI Brasil por estado',
    stateConcentration: 'Concentración por Estado',
    southRegionDominance: 'Dominio de la Región Sur',
    expansionOpportunity: 'Oportunidad de Expansión',
    expansionOpportunityText: 'Presencia mínima en las regiones Norte/Noreste donde las necesidades de desarrollo de la juventud son mayores',
    members: 'miembros',
    ofMembership: 'de los miembros',
    
    // NEW: Training Insights Section
    trainingInsights: 'Participación en Capacitación',
    trainingInsightsDescription: 'Tasas de finalización de cursos de capacitación de JCI Brasil',
    noTrainingCompleted: 'Sin Capacitación Completada',
    trainingGapAlert: 'de los miembros no han completado ningún curso de capacitación JCI',
    courseCompletionRates: 'Tasas de Finalización de Cursos',
    completionRate: 'Finalización',
    
    // NEW: SDG Preferences Section  
    sdgPreferences: 'Prioridades de Miembros en ODS',
    sdgPreferencesDescription: 'Principales ODS de interés entre los miembros de JCI Brasil (próximos 3 años)',
    memberInterest: 'Interés de los Miembros',
    topPriority: 'Prioridad Principal',
    alignsWithNationalNeeds: 'Alineado con los desafíos nacionales de la juventud',
    
    // Sample label
    sample: 'Muestra',

    // SWOT Items (20 keys)
    swotItems: {
      companionship: 'Compañerismo',
      committedLeadership: 'Liderazgo comprometido',
      continuousTraining: 'Capacitación continua',
      purposeInDna: 'Propósito en el ADN',
      qualityNetworking: 'Networking de calidad',
      inflatedEgos: 'Egos inflados',
      bureaucracy: 'Burocracia',
      inconclusiveProcesses: 'Procesos inconclusos',
      closedOrganization: 'Organización cerrada',
      lackOfMarketing: 'Falta de marketing',
      grantsAndSponsorships: 'Becas y patrocinios',
      personalDevelopmentNecessity: 'Necesidad de desarrollo personal',
      marketDemandsNewLeaders: 'El mercado demanda nuevos líderes',
      digitalPlatforms: 'Plataformas digitales',
      digitalMarketing: 'Marketing digital',
      rapidSocietalChange: 'Cambio comportamental rápido de la sociedad',
      digitalEntertainment: 'Entretenimiento digital',
      growingNgos: 'Creciente número de ONGs sociales',
      lackOfRecognizedProjects: 'Falta de proyectos reconocidos',
      societyWithoutTime: 'Sociedad sin tiempo',
    },

    // SDG Titles (9 keys)
    sdgTitles: {
      qualityEducation: 'Educación de Calidad',
      goodHealth: 'Salud y Bienestar',
      decentWork: 'Trabajo Decente y Crecimiento Económico',
      peaceJustice: 'Paz, Justicia e Instituciones Sólidas',
      reducedInequalities: 'Reducción de las Desigualdades',
      genderEquality: 'Igualdad de Género',
      noPoverty: 'Fin de la Pobreza',
      sustainableCities: 'Ciudades y Comunidades Sostenibles',
      climateAction: 'Acción por el Clima',
    },

    // Training Courses (10 keys)
    trainingCourses: {
      jciImpact: 'JCI Impact',
      jciAchieve: 'JCI Achieve',
      projectManagement: 'Gestión de Proyectos',
      jciAdmin: 'JCI Admin',
      effectiveLeadership: 'Liderazgo Efectivo',
      networking: 'Networking',
      communications: 'Comunicaciones',
      presenter: 'Presentador',
      leadershipAcademy: 'Academia de Liderazgo',
      jciDiscover: 'JCI Discover',
    },

    // Brazil-specific Demographics
    brazilDemographics: {
      urbanPopulationBrazil: 'Mayoría urbana, ~16M en favelas',
    },

    // Research Methodologies (5 keys)
    methodologies: {
      methodologyAtlas: 'Investigación en tres etapas: análisis cuantitativo (datos IBGE), entrevistas cualitativas, recomendaciones políticas',
      methodologySuaVoz: 'SurveyMonkey, 40,7% de tasa de respuesta, ±4% de margen de error, 95% de confianza',
      methodologyConjuve: 'Encuesta nacional de juventud sobre actitudes y desafíos',
      methodologyConvid: 'Encuesta conductual de salud mental de adolescentes',
      methodologyAtlasViolencia: 'Análisis de datos de homicidio y violencia',
    },

    // Brazil-specific Recommendations (12 keys)
    brazilRecommendations: {
      urgentRec1: 'Abordar la crisis NEET de mujeres negras/pardas (tasa del 43,3%)',
      urgentRec2: 'Expandir programas de salud mental para ansiedad climática',
      urgentRec3: 'Lanzar capítulos regionales en Norte/Noreste',
      urgentRec4: 'Asociarse con CUFA para alcance en comunidades de favelas',
      mediumRec1: 'Escalar programas NextGen y JOAJU IT a nivel nacional',
      mediumRec2: 'Desarrollar rutas educativas específicas de JCI',
      mediumRec3: 'Crear capacitación de defensores de salud mental para miembros',
      mediumRec4: 'Construir alianzas formales con redes de mujeres emprendedoras',
      longRec1: 'Posicionar a JCI Brasil como socio clave para la agenda juvenil de COP 30',
      longRec2: 'Abordar la transición demográfica con inversión estratégica en juventud',
      longRec3: 'Lograr equilibrio de género 50-50 con enfoque en equidad racial',
      longRec4: 'Establecer presencia en los 27 estados brasileños',
    },
  },
};
